var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudSlug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 25,
    viewBox: "0 0 51 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4862 12.6396C-3.67083 6.6891 -0.585637 24.5406 3.82206 24.5406C5.63294 24.5406 9.3867 24.9814 13.9603 24.9814H27.8448C45.4756 24.9814 50.5446 23.806 50.7652 23.4386C52.3079 11.7581 42.9781 12.86 37.9826 14.1823C38.7907 9.84802 37.9385 1.09126 28.0648 0.738635C18.1911 0.386013 16.8983 8.52569 17.4862 12.6396Z",
    fill: "#FFF9F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSlug);
export default __webpack_public_path__ + "static/media/cloud_slug.a155391bffd09af2f54d88f031cca3ae.svg";
export { ForwardRef as ReactComponent };